<template>
	<div v-click-outside="closeModal" class="app-top-info__edit-container">
		<div class="app-top-info__edit-container__title">{{ truncatedTitle }}</div>
		<div
			v-if="showEditModal && !isQuestionButton"
			@click="showModal"
			:class="
				!isOpenModal
					? 'app-top-info__edit-container__modal-button'
					: 'app-top-info__edit-container__modal-button-active'
			"
		>
			<Icon type="ellipsis" :size="20" :color="'var(--text_button_tint)'" />
		</div>
		<div
			@click="openAskModal"
			class="app-top-info__edit-container__qn-button"
			v-if="isQuestionButton"
		>
			Ask
		</div>
		<div v-if="isOpenModal" class="app-top-info__edit-container__modal-button__modal">
			<div
				@click="toggleEditPostModal"
				class="app-top-info__edit-container__modal-button__edit"
			>
				{{ isTypePost ? 'Edit Poll' : 'Edit Post' }}
			</div>
			<div
				v-if="!isForumPost"
				@click="toggleDeletePostModal"
				class="app-top-info__edit-container__modal-button__delete"
			>
				Delete Post
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { EventBus } from '@/services/event-bus'

export default {
	data() {
		return {
			isOpenModal: false,
		}
	},
	props: {
		showEditModal: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		...mapGetters('advertisement', ['isTypePost']),
		...mapGetters('app', ['pageTitle']),
		truncatedTitle() {
			const maxLength = 40
			if (!this.pageTitle) return ''
			return this.pageTitle.length > maxLength
				? this.pageTitle.slice(0, maxLength) + '...'
				: this.pageTitle
		},
		isForumPost() {
			return this.$route.name === 'forum-by-id'
		},
		isQuestionButton() {
			return this.$route.name === 'event-session-questions'
		},
	},

	methods: {
		...mapActions('advertisement', ['togglePostModal', 'togglePostDeleteModal']),
		showModal() {
			this.isOpenModal = !this.isOpenModal
		},
		openAskModal() {
			EventBus.$emit('openQuestionModal')
		},
		toggleEditPostModal() {
			this.togglePostModal()
			this.isOpenModal = false
		},
		toggleDeletePostModal() {
			this.togglePostDeleteModal()
			this.isOpenModal = false
		},
		closeModal() {
			if (!this.isOpenModal) return
			this.isOpenModal = false
		},
	},
}
</script>

<style lang="scss">
.app-top-info {
	&__edit-container {
		max-width: 555px;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		position: relative;
		&__qn-button {
			font-family: 'Inter', sans-serif;
			font-weight: 700;
			font-size: 14px;
			line-height: 100%;
			letter-spacing: 0;
			color: var(--text_button_tint);
			cursor: pointer;
		}

		&__title {
			max-width: 300px !important;
			width: 100%;
			font-family: 'Inter', sans-serif;
			font-weight: 700;
			font-size: clamp(14px, 2.5vw, 24px);
			line-height: 100%;
			white-space: nowrap;
			color: #4a4a4a;
		}
		&__modal-button-active {
			width: 40px;
			height: 40px;
			border: 1.5px solid var(--text_button_tint);
			box-shadow: 0 0 0 2px #0055a333;
			border-radius: 8px;
			padding: 8px;
			display: flex;
			align-items: center;
			justify-content: center;
			position: relative;
		}

		&__modal-button {
			width: 40px;
			height: 40px;
			border: 1px solid #e2e2e2;
			border-radius: 8px;
			padding: 8px;
			display: flex;
			align-items: center;
			justify-content: center;
			position: relative;

			&__modal {
				width: 250px;
				height: 106px;
				position: absolute;
				top: 45px;
				right: 0;
				background-color: #ffffff;
				padding: 12px;
				z-index: 1000;
				border-radius: 8px;
				border: 1px solid #e2e2e2;
			}

			&__edit {
				padding: 12px;
				cursor: pointer;
				font-family: 'Inter', sans-serif;
				font-weight: 400;
				font-size: 12px;
				line-height: 16.94px;
				color: var(--text_button_tint);
			}

			&__delete {
				padding: 12px;
				cursor: pointer;
				font-family: 'Inter', sans-serif;
				font-weight: 400;
				font-size: 12px;
				line-height: 16.94px;
				color: #ff3b30;
			}
		}
	}
}
</style>
